Use this section when you need to create or inspect seed workflows from the
Canary CLI. The conceptual model lives in `seed-workflows`; this section is
only command orientation. Prefer each command's `--help` output for the
current flag list.

CREATE A SIMPLE SEED SHELL

  For simple data outputs, create the seed shell with repeatable output
  declarations:

    canary workflow seed create \
      --name "Create Test Project" \
      --description "Provisions a test project with default settings" \
      --output "project_id:Project ID:The created project's UUID" \
      --output "project_name:Project Name"

  This creates a draft seed workflow and, by default, a paired teardown
  workflow linked to the seed.

CREATE A COMPLEX SEED SHELL

  For credential outputs or larger configs, put the full seed definition in a
  JSON file and create from that file:

    canary workflow seed create --from-file seed.json

  Keep generated credential fields in credentialOutput, and keep exported data
  fields in outputs. Downstream workflows consume both through $var.{dataKey}.

AFTER CREATION

  Add the seed body through the Flow Designer or workflow sync, test both the
  seed and teardown, then publish. If the seed can be API-backed, generate or
  attach an API sequence after the browser version is proven.

REFERENCE

  - Seed command help: `canary workflow seed --help`
  - Workflow sync help: `canary workflow sync --help`
